module.exports = __webpack_public_path__ + "img/NewMotoIcon.531c8139.svg";